import type {
  AddEditClinicianRequestT,
  ClinicianIdentityProofingRequestT,
  EmployeeRecordT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { formatPhoneNumber } from '@/shared/lib/formatters';

import { toMdy } from './date-of-birth';
import { createEmptyDemographicInfo } from './demographic-info-schema';
import { LOTUS_OFFICE_DEFAULTS } from './lotus-office-defaults';
import { createEmptyClinicianInfo } from './prescriber-details-model';

function splitDisplayName(displayName: string): { first: string; last: string } {
  const trimmed = displayName.trim();
  const spaceIndex = trimmed.indexOf(' ');
  if (spaceIndex === -1) return { first: trimmed, last: '' };
  return { first: trimmed.slice(0, spaceIndex), last: trimmed.slice(spaceIndex + 1) };
}

export function prescriberDefaultsFromEmployeeRecord(
  record: EmployeeRecordT
): AddEditClinicianRequestT {
  const { first, last } = splitDisplayName(record.displayName ?? '');
  return {
    ...createEmptyClinicianInfo(),
    ...LOTUS_OFFICE_DEFAULTS,
    FirstName: first,
    LastName: last,
    DateOfBirth: toMdy(record.dateOfBirth ?? ''),
    NPINumber: record.npiNumber ?? '',
    ClinicianRoleType: ['1'],
  };
}

export function demographicDefaultsFromEmployeeRecord(
  record: EmployeeRecordT
): ClinicianIdentityProofingRequestT {
  const { first, last } = splitDisplayName(record.displayName ?? '');
  return {
    ...createEmptyDemographicInfo(),
    FirstName: first,
    LastName: last,
    DateOfBirth: toMdy(record.dateOfBirth ?? ''),
    HomeAddress: record.mailingAddressStreet ?? '',
    City: record.mailingAddressCity ?? '',
    State: record.mailingAddressState ?? '',
    ZipCode: record.mailingAddressZip ?? '',
    PhoneNumber: formatPhoneNumber(record.phoneNumber),
  };
}
